import VuexPersistence from 'vuex-persist'

export default ({ store, $localforage }) => {
  localStorage.removeItem('telemetry')
  // Use reducer to persist all relevant state but deliberately exclude `isOffline`:
  // that flag must always be derived fresh from navigator.onLine at startup (see store/offline.js).
  // Persisting it causes a stale value to be restored on the next session.
  new VuexPersistence({
    reducer: state => ({
      auth: state.auth,
      coaching: state.coaching,
      version: state.version,
      offline: (({ isOffline, ...syncState }) => syncState)(state.offline),
    }),
  }).plugin(store)
  new VuexPersistence({
    key: 'vacation',
    modules: ['vacationRunManager'],
  }).plugin(store)
  new VuexPersistence({
    key: 'lists',
    modules: ['routePlan', 'forms', 'parameters'],
    asyncStorage: true,
    storage: $localforage,
  }).plugin(store)
  new VuexPersistence({
    key: 'telemetry',
    modules: ['telemetry'],
    asyncStorage: true,
    storage: $localforage,
  }).plugin(store)
  new VuexPersistence({
    key: 'hierarchy',
    storage: $localforage,
    asyncStorage: true,
    reducer: state => ({
      hierarchy: {
        data: state.hierarchy.data,
        lastSyncDate: state.hierarchy.lastSyncDate,
      },
    }),
  }).plugin(store)
  new VuexPersistence({
    key: 'portfolio',
    storage: $localforage,
    asyncStorage: true,
    reducer: state => ({
      portfolio: {
        data: state.portfolio.data,
        lastSyncDate: state.portfolio.lastSyncDate,
      },
      clientOptions: {
        categories: state.clientOptions.categories,
        lastSyncDate: state.clientOptions.lastSyncDate,
      },
    }),
  }).plugin(store)
  new VuexPersistence({
    key: 'research',
    storage: $localforage,
    asyncStorage: true,
    modules: ['research'],
  }).plugin(store)
}
